<template>
  <b-table :items="value" :fields="fields" responsive show-empty empty-text="There are no sessions yet">
    <template v-slot:cell(userAgent)="{ item: { userAgent }, value: { browser, os, platform } }">
      <div class="d-flex flex-row align-items-center" v-b-tooltip.hover :title="userAgent">
        <font-awesome-icon class="mx-1" :icon="[ browser.style, browser.name ]" size="lg"/>
        <font-awesome-icon class="mx-1" :icon="[ os.style, os.name ]" size="lg"/>
        <font-awesome-icon class="mx-1" :icon="[ platform.style, platform.name ]" size="lg"/>
      </div>
    </template>
  </b-table>
</template>

<script>
import _capitalize from 'lodash/capitalize';
import formatDate from 'date-fns/format';
import { faUserAgent } from 'fontawesome-user-agent';

export default {
  props: {
    value: {
      type: Array,
    },
  },
  computed: {
    fields: () => ([
      { key: 'id', label: 'ID' },
      { key: 'ipAddress', label: 'IP Address' },
      { key: 'userAgent', formatter: value => faUserAgent(value) },
      { key: 'created', formatter: value => formatDate(value, 'DD/MM/YYYY HH:MM') },
      { key: 'updated', formatter: value => formatDate(value, 'DD/MM/YYYY HH:MM') },
      { key: 'status', formatter: value => _capitalize(value) },
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/users/Sessions.vue